import axios from 'axios'
import QS from 'qs';
import baseUrl from "./baseUrl";
import * as qiniu from 'qiniu-js';
import Cookies from 'js-cookie'
import { log } from 'three';

//请求超时时间。例如超过了10s，就会告知用户当前请求超时
axios.defaults.timeout = 10000

//axios默认请求头发起post的请求会发两遍，修改请求头后通过qs模块将数据处理后发送服务端
axios.defaults.headers.post['Content-Type'] = 'application/x-www-form-urlencoded;charset=UTF-8';
axios.defaults.headers.common["admin-token"] = localStorage.getItem("admin-token");
if(Cookies.get("admin-token")){
    axios.defaults.headers.common["admin-token"] = Cookies.get("admin-token");
}
axios.defaults.headers.common["user-ip"] = returnCitySN.cip;

/**
 * get方法，对应get请求
 * @param {String} url [请求的url地址]
 * @param {Object} params [请求时携带的参数]
 */
export function getData(url, params) {
    // console.log(sessionStorage.getItem("admin-token"));
    axios.defaults.timeout = 30000;
    axios.defaults.baseURL = '/api';
    axios.defaults.headers.common["admin-token"] = localStorage.getItem("admin-token");
    if(Cookies.get("admin-token")){
        axios.defaults.headers.common["admin-token"] = Cookies.get("admin-token");
    }
    axios.defaults.headers.common["user-ip"] = returnCitySN.cip;
    return new Promise((resolve, reject) => {
        axios.get(url, {
            params: params
        })
            .then(res => {
                resolve(res);
            })
            .catch(err => {
                reject(err)
            })
    });
}

/**
 * post方法，对应post请求
 * @param {String} url [请求的url地址]
 * @param {Object} params [请求时携带的参数]
 */
export function postData(url, params) {
    axios.defaults.baseURL = '/api'
    if(url == '/admin/log/composite' || url == '/admin/log/index') {
        axios.defaults.timeout = 1000000
    } else {
        axios.defaults.timeout = 30000
    }
    axios.defaults.headers.common["admin-token"] = localStorage.getItem("admin-token");
    if(Cookies.get("admin-token")){
        axios.defaults.headers.common["admin-token"] = Cookies.get("admin-token");
    }
    axios.defaults.headers.common["user-ip"] = returnCitySN.cip;
    return new Promise((resolve, reject) => {
        // axios.post(url, QS.stringify(params))
        axios.post(url, params)
            .then(res => {
                resolve(res);
            })
            .catch(err => {
                reject(err)
            })
    });
}
/**
 * post方法，对应post请求
 * @param {String} url [请求的url地址]
 * @param {Object} params [请求时携带的参数]
 */
 export function postDataQS(url, params) {
    axios.defaults.baseURL = '/api'
    if(url == '/admin/log/composite' || url == '/admin/log/index') {
        axios.defaults.timeout = 1000000
    } else {
        axios.defaults.timeout = 30000
    }
    axios.defaults.headers.common["admin-token"] = localStorage.getItem("admin-token");
    if(Cookies.get("admin-token")){
        axios.defaults.headers.common["admin-token"] = Cookies.get("admin-token");
    }
    axios.defaults.headers.common["user-ip"] = returnCitySN.cip;
    return new Promise((resolve, reject) => {
        axios.post(url, QS.stringify(params))
            .then(res => {
                resolve(res);
            })
            .catch(err => {
                reject(err)
            })
    });
}

export function warrantPostData(url, params, key, token) {
    axios.defaults.headers.common["admin-token"] = localStorage.getItem("admin-token");
    if(Cookies.get("admin-token")){
        axios.defaults.headers.common["admin-token"] = Cookies.get("admin-token");
    }
    axios.defaults.headers.common["user-ip"] = returnCitySN.cip;
    axios.defaults.headers.common[key] = token;
    return new Promise((resolve, reject) => {
        axios.post(url, QS.stringify(params))
            .then(res => {
                resolve(res);
            })
            .catch(err => {
                reject(err)
            })
    });
}

// 阿里云上传
export async function OSSuploadPost({res,callback,progress,type = 'image'} = option){
    console.log('upload------------>')
    let obj1 = await get_signature(res.file.name,type)
    let obj = JSON.parse(obj1)
    var formData = new FormData();
    formData.append('key', obj.data.key);
    formData.append('OSSAccessKeyId', obj.data.uptoken.accessid);
    formData.append('policy', obj.data.uptoken.policy);
    formData.append('Signature', obj.data.uptoken.signature);
    formData.append('success_action_status', 200); //成功后返回的操作码
    formData.append("file", res.file);
    var url = obj.data.uptoken.host;
    $.ajax({
      url: url,
      type: 'POST',
      data: formData,
      cache: false,
      contentType: false,
      processData: false,
      xhr: function() {
      var xhr = null;
          if (window.XMLHttpRequest){
          xhr=new XMLHttpRequest();
          }else if (window.ActiveXObject){
          xhr=new ActiveXObject("Microsoft.XMLHTTP");
          }
          xhr.upload.addEventListener('progress', function (progressEvent) {
              progress && progress(progressEvent, res)
          })
          return xhr;
      },
      success: function (data) {
          let url = type == 'video'||type == 'videosource'?obj.data.key:`${obj.data.domain}/${obj.data.key}`
          res.onSuccess&&res.onSuccess({
            file_url: url,
            domain:obj.data.domain
          })
          callback && callback(url, res,obj.data.domain)
      },
      error: function (err) {
          console.log('err',err);
          res.onSuccess&&res.onSuccess()
      }
    });
  }
  // 阿里云上传 获取签名
  function get_signature(filename,type = 'image') {
  return new Promise(res =>{
      var param = {
          type: type,
          file_name: filename,
      };
      postDataQS('/admin/upload/getToken', param).then(res1 => {
          res(res1.data)
      })
  })
  }
//七牛云 上传凭证接口
export function qiniuPost(data, that, item, callback) {
    console.log(data.file)
    var _this = this;
    var param = {
        file_name: data.file.name,
    };
    var file_size = 0;
    var config = {
        useCdnDomain: true,
        region: qiniu.region.z2
    };
    postData('/admin/upload/getToken', param).then(res => {
        var observable = qiniu.upload(
            data.file,
            res.data.data.key,
            res.data.data.uptoken,
            {
                fname: data.file.name,
                params: {},
                mimeType: [],
            },
            {
                useCdnDomain: true,
            },
        );
        observable.subscribe({
            next(res) {
                console.log('next');
                console.log(res);
                file_size = res.total.size;
            },
            error(err) {
                console.log('error:');
                console.log(err);
                data.onSuccess();
                console.log('error//');
            },
            complete(sub_res) {
                //根据上传成功信息返回图片
                var file_url = res.data.data.domain + res.data.data.key;
                data.onSuccess({"type": item, "file_url": file_url});
                that[item] = file_url;
                if (typeof that.ruleForm != 'undefined') {
                    that.ruleForm[item] = file_url;
                }
                if (callback) {
                    callback && callback(file_url, that);
                } else {
                    that.$loading().close();
                }
                console.log(item, that[item]);

            }
        })
    });
}

//七牛云 上传凭证接口
export function qiniuPostNew(data, callback) {
    var _this = this;
    var param = {
        file_name: data.file.name,
    };
    var file_size = 0;
    var config = {
        useCdnDomain: true,
        region: qiniu.region.z2
    };
    postData('/admin/upload/getToken', param).then(res => {
        var observable = qiniu.upload(
            data.file,
            res.data.data.key,
            res.data.data.uptoken,
            {
                fname: data.file.name,
                params: {},
                mimeType: [],
            },
            {
                useCdnDomain: true,
            },
        );
        observable.subscribe({
            next(res) {
                console.log('next');
                console.log(res);
                file_size = res.total.size;
            },
            error(err) {
                console.log('error:');
                console.log(err);
                data.onSuccess();
                console.log('error//');
            },
            complete(sub_res) {
                //根据上传成功信息返回图片
                var file_url = res.data.data.domain + res.data.data.key;
                data.onSuccess({"file_url": file_url});
                console.log("上传成功，正在返回地址")
                callback(file_url);
                // that.$loading().close();
            }
        })
    });
}


/**
 * post方法，对应post携带文件请求
 * @param {String} url [请求的url地址]
 * @param {Object} params [请求时携带的参数]
 */
export function filepostData(url, params, progress, callback) {
    axios.defaults.timeout = 100000000
    axios.defaults.baseURL = '/api'
    axios.defaults.headers.common["member-token"] = localStorage.getItem("admin-token");
    if(Cookies.get("admin-token")){
        axios.defaults.headers.common["admin-token"] = Cookies.get("admin-token");
    }
    axios.defaults.headers.post['Content-Type'] = 'multipart/form-data';
    axios.defaults.headers.common["user-ip"] = returnCitySN.cip;

        axios.post(url, params, {
            onUploadProgress(progressEvent) {
                progress && progress(progressEvent, params)
            }
        })
            .then(res => {
                callback(res)
            })
            .catch(err => {
                console.log(err);
                callback(err)
            })
}



/**
 * post方法，对应post携带文件请求
 * @param {String} url [请求的url地址]
 * @param {Object} params [请求时携带的参数]
 */
export function filepostDatas(url, params, progress, callback) {
    axios.defaults.timeout = 100000000
    axios.defaults.baseURL = '/api'
    axios.defaults.headers.common['member-token'] = localStorage.getItem('member-token')
    axios.defaults.headers.post['Content-Type'] = 'multipart/form-data'
    axios.defaults.headers.common['user-ip'] = returnCitySN.cip
  
    return new Promise((resolve, reject) => {
      axios
        .post(url, params, {
          onUploadProgress(progressEvent) {
            progress && progress(progressEvent, params)
          }
        })
        .then((res) => {
          resolve(res)
          callback && callback(res, params)
        })
        .catch((err) => {
          reject(err)
        })
    })
  }

export function update_getData(url, params) {
    // console.log(sessionStorage.getItem("admin-token"));
    axios.defaults.timeout = 30000;

    axios.defaults.baseURL = '/update_file'
    axios.defaults.headers.common["admin-token"] = localStorage.getItem("admin-token");
    if(Cookies.get("admin-token")){
        axios.defaults.headers.common["admin-token"] = Cookies.get("admin-token");
    }
    axios.defaults.headers.common["user-ip"] = returnCitySN.cip;
    return new Promise((resolve, reject) => {
        axios.get(url, {
            params: params
        })
            .then(res => {
                resolve(res);
            })
            .catch(err => {
                reject(err)
            })
    });
}



// WEBPACK FOOTER //
// ./src/summary/assets/js/httpRequest.js